import { render, staticRenderFns } from "./GPathCareerUnivList.vue?vue&type=template&id=29ff553a"
import script from "./GPathCareerUnivList.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports